

















import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import { ViewpointApi, VIEWPOINT_API } from '@/api/ViewpointApi';
import Apps from '@/store/modules/Apps';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Decision from '@/store/modules/Decisions';
import { AppModel } from '@/api/model/AppModel';
import _ from 'lodash';

const appModule = getModule(Apps);
const decisionModule = getModule(Decision);
@Component({
    components: {
    },
})
export default class AppsSubscribeButton extends Vue {
    @Prop({ default: '', type: String })
    selectedAppId!: string;

    @Prop()
    selectedAppProp!: any;

    @Prop()
    currentUserId!: string;

    get decisionId() {
        return decisionModule.selectedDecisionId;
    }

    get isSubscribed() {
        // console.log(this.selectedAppProp);
        if (this.selectedAppProp != null) {
            return this.selectedAppProp?.userIds
                ? this.currentUserId in this.selectedAppProp.userIds
                : false;
        } else return false;
    }

    get appsDictionary() {
        return appModule.appsDictionary;
    }

    private async installApp() {
        this.selectedAppProp.subscriptionStatus = true
        console.log(this.selectedAppProp)
        await appModule.addUserToApp({ id: this.selectedAppProp.id, userId: this.currentUserId})
        await appModule.installApp(this.selectedAppProp)
        // // clone the ORIGINAL SOURCE Decision (based on decisionIdRef) into that User's owned Decisions
        // cloneDecision.decisionTemplateId = this.selectedAppProp.decisionIdRef
        // let result = await decisionModule.copyIntoNewDecision(cloneDecision)
        // await appModule.updateAppIds({newDecisionId: result.decision.decisionId, oldDecision: this.selectedAppProp.decisionIdRef})
        // when creating the NEW Decision, make sure to set its "decisionTemplateId" value to the "id" of the TEMPLATE (from Apps endpoint) that this Decisions was cloned from
        // clone the ORIGINAL SOURCE Apps (based on appIdRef key value) into that User's owned Apps for that newly created Decision (need this new decisionId when creating these new Apps)
        // when creating these NEW Apps, make sure to set their "appTemplateId" value to the "id" of the APP (from Apps endpoint) that these Apps were cloned from
    }

    private async uninstallApp() {
        this.selectedAppProp.subscriptionStatus = false;
        appModule.removeUserFromApp({
            id: this.selectedAppProp.id,
            userId: this.currentUserId,
        });
    }
}
